import styled, { css } from 'styled-components';
import { blockRightMouseStyle } from '@styles/common/BlockLeftMouse';

export const DetailTitleSec = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 24px;
  .subTitle {
  }
`;

export const DetailTitle = styled.h3`
  font-weight: 800;
`;

export const ContentsWrap = styled.div<{
  blockMouse?: boolean;
  showWide?: boolean;
}>`
  z-index: 0;
  height: fit-content;
  overflow: visible;

  &.ql-editor {
    overflow: visible;
  }

  ${({ blockMouse }) => blockMouse && blockRightMouseStyle}
`;

export const InfoWrap = styled.div`
  display: flex;
  gap: 12px;
  color: var(--subTextColor);
  align-items: center;

  @media (max-width: 460px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DetailContents = styled.div`
  width: 100%;
  height: fit-content;
  overflow: visible;
  p {
    img {
      max-width: 100%;
    }
  }

  img {
    max-width: 100%;
  }

  iframe {
    max-width: 100%;
  }

  .twitter-tweet,
  .twitter-tweet-rendered {
    max-width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

`;

export const InfoSec = styled.div`
  color: var(--subTextColor);
  font-size: 13px;
  display: flex;
  gap: 4px;
`;

export const PrevNextBtnSec = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 80px 0;

  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

export const PageControlBtnBox = styled.div`
  padding: 16px;
  border-radius: var(--cardBorderRadius);
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--lineColor);
  color: var(--subTextColor);
  width: 100%;
  max-width: 240px;
  display: grid;
  align-items: center;
  grid-gap: 12px;
  transition: border 0.2s;

  .docLabel {
    line-height: normal;
    font-size: 13px;
    margin-bottom: 4px;
  }
  .prevTitle {
    line-height: normal;
    font-weight: 800;
    /* ellipsis */
    max-height: 20px;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    /* ellipsis end */
  }

  &.prevDoc {
    grid-template-columns: 1fr 8fr;
  }

  &.nextDoc {
    grid-template-columns: 8fr 1fr;

    .contentSec {
      text-align: right;
    }
  }

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    color: var(--textColor);

    .circleBtn {
      background-color: $custom-button-Bg-color;

      &.prevAni {
        transform: translateX(-5px);
      }

      &.nextAni {
        transform: translateX(5px);
      }
    }
  }

  @media (max-width: 460px) {
    max-width: 100%;
  }
`;

export const PageControlCircle = styled.div`
  background-color: var(--primaryColor);
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-out;
  user-select: none;

  &:hover {
    &.prevAni {
      transform: translateX(-5px);
    }

    &.nextAni {
      transform: translateX(5px);
    }
  }

  &.hidden {
    visibility: hidden;
  }
`;

export const CloseSideBtn = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--backgroundColor);
  border: 1px solid var(--lineColor);
  border-radius: 50px;
  position: absolute;
  top: 24px;
  left: -12px;

  @media (max-width: 460px) {
    display: none;
  }
`;
